import { ReactNode, useState } from "react"

import { ContentObjectItem } from "@vertesia/common"

import { UploadDocumentsModal } from "@components/modals/UploadDocumentsModal"

interface UploadDocumentsButtonProps {
    children: ReactNode
    collectionId?: string | undefined
    onUploadDone: (uploadedIds: string[]) => void
}
export function UploadDocumentsButton({ children, collectionId, onUploadDone }: Readonly<UploadDocumentsButtonProps>) {
    const [open, setOpen] = useState(false)

    const handleOnUploadDone = (uploadedIds: ContentObjectItem[]) => {
        onUploadDone(uploadedIds.map((item) => item.id))
    }

    return (
        <>
            <div onClick={() => setOpen(true)} className="w-full">
                {children}
            </div>
            <UploadDocumentsModal open={open} onOpenChange={setOpen} onUploadDone={handleOnUploadDone} collectionId={collectionId} />
        </>
    )
}
